export const HomeViewUrl = "/";

export const TrainingViewUrl = "/training/view";
export const ExerciseViewUrl = "/training/exercises";
export const MaximumExerciseViewUrl = "/training/maximum";
export const TrainingAddUrl = "/training/add";
export const TrainingStatisticUrl = "/training/statistics";

export const Training = "training";
export const View = "view";
export const Exercises = "exercises";
export const Maximum = "maximum";

export const FoodViewUrl = "/food/view";
export const FoodAddUrl = "/food/add";
export const CalculateIngredientsUrl = "/food/statistics";
export const FoodProductUrl = "/food/products";

export const Food = "food";
export const Add = "add";
export const Edit = "edit";
export const Products = "products";
export const Statistics = "statistics";

export const ShoppingViewUrl = "/other/shopping";
export const WeeklyViewUrl = "/other/weekly";
export const DailyViewUrl = "/other/daily";

export const Other = "other";
export const Shopping = "shopping";
export const Weekly = "weekly";
export const Daily = "daily";

export const LoginUrl = "/login";
export const SignUpUrl = "/sign-up";
export const LogoutUrl = "/logout";

export const FinanceViewUrl = "/finance/view";
export const FinanceConfigUrl = "/finance/information";

export const Finance = "finance";
export const Information = "information";

export const TimerChallengeUrl = "/projects/timer-challenge";
export const HolidayPickerUrl = "/projects/vacations";

export const Projects = "projects";
export const TimerChallenge = "timer-challenge";
export const HolidayPicker = "vacations";